import { Box, CircularProgress, Grid, Typography } from '@mui/material'
import React from 'react'

const Assets = ({ sortedAssets, isLoading, isError }) => {
    return (
        <Box
            sx={{
                borderRadius: 3,
                border: "1px solid #eef0f4",
                p: 2,
                width: "100%",
                height: "100%",
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                maxHeight: { md: "295px", xs: "auto" },
                // overflowY: "auto"
            }}
        >

            <Typography variant="h6" sx={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 600,
                fontSize: "20px",
                lineHeight: "32px",
                letterSpacing: "0px",
                mb: "4px",
            }}>
                Assets
            </Typography>

            {/* <Typography
                sx={{
                    fontFamily: "Outfit, sans-serif",
                    fontWeight: 300,
                    fontSize: "16px",
                    lineHeight: "32px",
                    letterSpacing: "0px",
                    mb: "20px",
                }}
            >
                Project Assets
            </Typography> */}

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    overflowY: "auto"
                }}
            >
                {isLoading && (
                    <Grid size={12}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                py: 6,
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    </Grid>
                )}


                {isError && (
                    <Grid size={12}>
                        <Typography color="error">
                            Failed to load assets data.
                        </Typography>
                    </Grid>
                )}
                {!isLoading && !isError && sortedAssets?.length > 0 ? (
                    sortedAssets.map((asset, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 0.5,
                                p: 0.4,
                                borderRadius: 1,
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: "#eeeeee"
                                }
                            }}
                        >
                            {asset.assetName}
                        </Box>
                    ))
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        No assets available
                    </Typography>
                )}
            </Box>
        </Box>
    )
}

export default Assets
